import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';

import { theme } from '@garnish/constants';
import { DisplayText, Icon, TextSpace, useResponsive } from '@garnish/core';
import { type AddressType } from '@garnish/location';

import { ICON_SIZE, ICON_SIZE_SMALLER } from '../utils';

export const OrderPlaybackTime = (props: OrderPlaybackTimeProps) => {
  const { orderChannel, date, time } = props;

  const { minWidth, currentHeight } = useResponsive();
  const withSmallerFont = minWidth.isSM && currentHeight.isSM;
  const fontSize: '16' | '24' = withSmallerFont ? '16' : '24';

  return (
    <View style={styles.row}>
      <View style={withSmallerFont ? styles.iconSmaller : styles.icon}>
        <Icon
          name="IconOrderPlaybackTime"
          color={theme.colors.KALE}
          width={withSmallerFont ? ICON_SIZE_SMALLER : ICON_SIZE}
          height={withSmallerFont ? ICON_SIZE_SMALLER : ICON_SIZE}
        />
      </View>

      <View>
        <Text>
          <DisplayText style={styles.text} bold sizeMatch={[fontSize]}>
            {date}
          </DisplayText>

          <TextSpace />

          {orderChannel === 'delivery' ? (
            <DisplayText style={styles.text} sizeMatch={[fontSize]}>
              <FormattedMessage {...messages.between} />
            </DisplayText>
          ) : (
            <DisplayText style={styles.text} sizeMatch={[fontSize]}>
              <FormattedMessage {...messages.at} />
            </DisplayText>
          )}

          {orderChannel === 'delivery' ? null : (
            <>
              <TextSpace />

              <DisplayText style={styles.text} bold sizeMatch={[fontSize]}>
                {time}
              </DisplayText>
            </>
          )}
        </Text>

        {orderChannel === 'delivery' ? (
          <DisplayText style={styles.text} bold sizeMatch={[fontSize]}>
            {time}
          </DisplayText>
        ) : null}
      </View>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  at: {
    defaultMessage: 'at',
    description: 'Bag | Order playback | At',
  },
  between: {
    defaultMessage: 'between',
    description: 'Bag | Order playback | Between',
  },
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.KALE,
  },
  icon: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    marginBottom: theme.spacing['1'],
  },
  iconSmaller: {
    width: ICON_SIZE_SMALLER,
    height: ICON_SIZE_SMALLER,
    marginBottom: theme.spacing['1'],
  },
  row: {
    flexDirection: 'row',
    gap: theme.spacing['3'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderPlaybackTimeProps = {
  orderChannel: AddressType;
  date: string;
  time: string;
};
